export const optimizeImageWidth = (imageUrl, width = 600) => {
  return imageUrl.replace('/original/', `/w-${width}/`);
};
